/**
 * 请求拦截器，用于记录请求日志。
 * */

import {comTag, RequestInterceptor} from '@/Fwk/Http/comRequest';
import Util from "@/Master/Util";

export const LogRequestInterceptor: RequestInterceptor = async (config) => {
    if (Util.isLog) {
        // console.log(comTag,'请求拦截器-日志:',config.url, config);
    }
    return config;
};
